import { Field, Form, FormikProps } from 'formik';
import { FormValues } from './types';
import styles from './ReportModal.module.css';
import CustomerField from './Customer';
import { FormikRadioGroupInput } from '../Forms/Components/RadioGroup';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';
import JobCategoryMultiSelectField from '../Forms/Fields/JobCategoryMultiSelect';
import { FormikCheckboxInput } from '../Forms/Components/CheckInput';
import ServiceDropdownField from '../Forms/Fields/ServiceDropdown';
import { LocationMultiSelectField } from '../Forms/Fields/Location';
import { Stack } from '@mui/material';

type ReportFormProps = FormikProps<FormValues> & {
	id: string;
};

export default function OpsProfitabilityForm({ id }: ReportFormProps) {
	return (
		<Stack
			spacing={3}
			sx={{ width: 500 }}
		>
			<Form
				className={styles['report-form']}
				id={id}
			>
				<div className={styles['flex-row']}>
					<Field
						component={FormikRadioGroupInput}
						name='dateType'
						label='Date Type:'
						labelPlacement='top'
						defaultOptionSelected='Delivery Date'
						radioItems={['Delivery Date', 'Invoice Date', 'Pickup Date']}
					/>
				</div>
				<div className={styles['flex-row']}>
					<div>
						<Field
							name='reportDateRange'
							component={FormikDateRangePicker}
							label='Date Range'
							className={styles['date-range-input']}
						/>
					</div>
				</div>
				<div className={styles['flex-row']}>
					<div className={styles['customer-dropdown']}>
						<CustomerField
							fieldName='customers'
							label='Customers'
							multiple
						/>
					</div>
				</div>
				<div className={styles['flex-row']}>
					<LocationMultiSelectField
						label='Consignees'
						fieldName='consignees'
						selectionOnly={true}
					/>
				</div>
				<div className={styles['flex-row']}>
					<JobCategoryMultiSelectField
						fieldName='jobCategories'
						className={styles['services-dropdown']}
					/>
				</div>
				<div className={styles['flex-row']}>
					<ServiceDropdownField
						fieldName='services'
						className={styles['services-dropdown']}
					/>
				</div>
				<div className={styles['flex-row']}>
					<div>
						<Field
							component={FormikRadioGroupInput}
							name='driverPay'
							label='Driver Pay:'
							labelPlacement='top'
							defaultOptionSelected='All'
							radioItems={['Approved', 'All']}
						/>
					</div>
				</div>
				<div className={styles['flex-row']}>
					<div className={styles['flex-30']}>
						<Field
							component={FormikCheckboxInput}
							name='totalsOnly'
							label='Show Customer Totals Only'
						/>
					</div>
					<div className={styles['incl-fsc-checkbox']}>
						<Field
							component={FormikCheckboxInput}
							name='inclFsc'
							label='Include FSC'
						/>
					</div>
				</div>
				<div className={styles['flex-row']}>
					<div>
						<Field
							component={FormikRadioGroupInput}
							name='accept'
							label='Report Format:'
							labelPlacement='top'
							defaultOptionSelected='HTML'
							radioItems={['HTML', 'Excel']}
						/>
					</div>
				</div>
				<div className={styles['flex-row']}>
					<div>
						<Field
							component={FormikRadioGroupInput}
							name='reportType'
							label='Report Style:'
							labelPlacement='top'
							defaultOptionSelected='Summary'
							radioItems={['Summary', 'Detail']}
						/>
					</div>
				</div>
			</Form>
		</Stack>
	);
}
